<template>
    <div>
        <PageTitle v-if="teatro.hash === 'Yrx8aEYi3uV8hv1UwnIq'" />
        <PageTitle v-else :title="teatro.hash === 'UHmERrsRV19JCGQMg7Is' ? $t('header.partidos_titulo', {titulo: lista_abonados.nombre}) :  $t('header.partidos_temporada', {temporada: lista_abonados.nombre})"/>
        <FirstBanner/>
        <ListadoEventosClubs 
            v-if="eventos.length > 0" 
            :eventos="eventos"
        />
        <template v-else>
            <NoEvents/>
        </template>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import ListadoEventosClubs from '@/components/frontend/events/listado/ListadoEventosClubs';
    import NoEvents from '@/components/frontend/events/listado/NoEvents';

    export default {
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            eventos() {
                var array = [];

                var ahora = moment();

                if(this.events && this.events.data) {
                    for (var i = 0; i < this.events.data.length; i++) {
                        var fecha = moment(this.events.data[i].fecha_sesion).add(2, 'hours');
                        if(ahora < fecha) {
                            array.push(this.events.data[i]);
                        }
                    }
                }                

                return array;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            events() {
                return this.$store.getters.getFrontEvents;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            PageTitle, ListadoEventosClubs, FirstBanner, NoEvents
        }
    }
</script>
